import { createContext } from 'react';

export interface AudioContext {
  onRecording: (id: string) => void;
  onStopRecorder: (callBackFn?: (audioIdRes: string, recordUrl?: string) => void) => void;
  idRecording?: string;
  idUploadAudio?: string;
  urlEndRecord: string | null;
  resetUploadId: () => void;
  recordUrlStore: string | null;
  isUploadingAudio: boolean;
}

export default createContext<AudioContext | undefined>(undefined);
